import React from 'react';
import * as LucideIcons from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TIER_OPTIONS = ['Inner Circle', 'Acquaintance', 'Following'];

const QuickActionsMenu = ({ isOpen, onClose, onSetTier, onRemoveConnection, onGiftEchoes, onShareProfile, onChallenge, currentTier }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    const tierDisplayNames = {
        'Inner Circle': t('quickActions.tiers.innerCircle'),
        'Acquaintance': t('quickActions.tiers.acquaintance'),
        'Following': t('quickActions.tiers.following'),
    };

    return (
        <div className="absolute top-12 right-0 z-20 w-56 bg-gray-900 border border-gray-700 rounded-lg shadow-lg animate-fadeIn a-short-delay">
            <div className="p-2">
                <p className="text-xs text-gray-400 px-2 mb-1 font-semibold">{t('quickActions.setTier')}</p>
                {TIER_OPTIONS.map(tier => (
                    <button
                        key={tier}
                        onClick={() => { onSetTier(tier); onClose(); }}
                        className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-white rounded-md hover:bg-gray-700/80"
                    >
                        {tier === currentTier ? <LucideIcons.CheckCircle2 size={16} className="text-cyan-400" /> : <LucideIcons.Circle size={16} className="text-gray-500" />}
                        {tierDisplayNames[tier]}
                    </button>
                ))}
            </div>
            <div className="border-t border-gray-700 p-2">
                <button
                    onClick={() => { onShareProfile(); onClose(); }}
                    className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-white rounded-md hover:bg-gray-700/80"
                >
                    <LucideIcons.Share2 size={16} />
                    {t('quickActions.shareProfile')}
                </button>
                <button
                    onClick={() => { onGiftEchoes(); onClose(); }}
                    className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-white rounded-md hover:bg-gray-700/80 mt-1"
                >
                    <LucideIcons.Gift size={16} />
                    {t('quickActions.giftEchoes')}
                </button>
                <button
                    onClick={() => { onChallenge(); onClose(); }}
                    className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-white rounded-md hover:bg-gray-700/80 mt-1"
                >
                    <LucideIcons.Swords size={16} />
                    {t('quickActions.challenge') || "Challenge"}
                </button>
                 <button
                    onClick={() => { onRemoveConnection(); onClose(); }}
                    className="w-full text-left flex items-center gap-2 px-2 py-1.5 text-sm text-red-400 rounded-md hover:bg-red-500/20 mt-1"
                >
                    <LucideIcons.UserX size={16} />
                    {t('quickActions.disconnect')}
                </button>
            </div>
        </div>
    );
};

export default QuickActionsMenu;
